<template>
  <div>
    <div v-for="(group, key) in groupedPages" :key="key" class="mb-4">
      <div v-if="group.type && !isCollapsed" class="group-label">
        {{ group.type }}
      </div>
      <ul class="flex flex-col gap-1" :class="isCollapsed ? '' : ''">
        <li v-for="(button, index) in group.items" :key="index" class="nav">
          <el-tooltip
            :content="button.title"
            placement="right"
            :disabled="!isCollapsed"
            :showAfter="300"
          >
            <router-link
              v-if="button.name"
              :to="{ name: button.name }"
              class="nav-link"
              :class="[
                isCollapsed ? 'short' : 'full',
                isCollapsed ? 'nav-link--collapsed' : '',
                getClassName(button.name),
              ]"
              @click="$emit('setActiveItemHandler', button.name)"
            >
              <div class="flex items-center gap-2">
                <svg-icon
                  v-if="button.icon"
                  :name="button.icon"
                  class="shrink-0"
                />

                <span v-if="!isCollapsed" class="nav-label">
                  {{ button.title }}
                </span>
              </div>
              <span v-if="!isCollapsed && button.badge" class="notif"
                >{{ button.badge }}
              </span>
            </router-link>
          </el-tooltip>
        </li>
      </ul>
    </div>

    <ul class="flex flex-col gap-1 mb-4">
      <li class="nav">
        <el-tooltip
          :content="$t('call.sidebarButton')"
          placement="right"
          :disabled="!isCollapsed"
          :showAfter="300"
        >
          <button
            type="button"
            class="nav-link call-trigger"
            :class="[isCollapsed ? 'short nav-link--collapsed' : 'full']"
            @click="onCallClick"
          >
            <div class="flex items-center gap-2">
              <svg-icon name="sli-camera" class="shrink-0" />
              <span v-if="!isCollapsed" class="nav-label">
                {{ $t("call.sidebarButton") }}
              </span>
            </div>
          </button>
        </el-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";
import { useCallWindow } from "@/widgets/call-window";

export default {
  name: "NavBar",
  components: {
    SvgIcon,
  },
  props: {
    isCollapsed: {
      type: Boolean,
    },
    activeItem: {
      type: String,
    },
    pages: {
      type: Array,
    },
  },
  emits: ["setActiveItemHandler"],
  methods: {
    onCallClick() {
      const { openCall } = useCallWindow();
      openCall();
    },
    getClassName(name) {
      if (name === "ai-assistant" || name === "client_ai_chat") {
        return "ai";
      }
      if (name === "calendar_events") {
        return "calendar";
      }
      if (name === "meet") {
        return "meet";
      }
      if (name === "todo") {
        return "todo";
      }
      return "";
    },
  },
  computed: {
    groupedPages() {
      const grouped = this.pages.reduce((acc, item) => {
        const { type } = item;
        if (!acc[type]) {
          acc[type] = { type, items: [] };
        }
        acc[type].items.push(item);
        return acc;
      }, {});

      return Object.values(grouped);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  @apply flex w-full items-center justify-between rounded-md px-2 py-1.5 gap-2 text-left text-sm border border-transparent;

  &.short {
    @apply justify-center px-0;
  }
  color: hsl(var(--sidebar-foreground));
  &:hover {
    @apply border border-border;
    background-color: rgb(var(--color-white));
    color: hsl(var(--sidebar-accent-foreground));

    svg {
      color: hsl(var(--sidebar-accent-foreground));
    }
  }

  svg {
    @apply flex justify-center  shrink-0;
    color: hsl(var(--sidebar-foreground));
    width: 18px;
    height: 18px;
  }

  &.ai {
    svg {
      color: rgb(var(--color-purple-700));
      fill: rgb(var(--color-purple-50));
    }
  }

  &.calendar {
    svg {
      color: rgb(var(--color-blue-400));
      fill: rgb(var(--color-blue-50));
    }
  }

  &.meet {
    svg {
      color: rgb(var(--color-red-600));
      fill: rgb(var(--color-red-300));
    }
  }

  &.todo {
    svg {
      color: rgb(var(--color-green-700));
      fill: rgb(var(--color-green-100));
    }
  }

  &.call-trigger {
    svg {
      color: rgb(var(--color-red-600));
      fill: rgb(var(--color-red-100));
    }
  }
}

.nav-label {
  @apply text-sm;
}

a.router-link-active {
  @apply border border-border;
  background-color: rgb(var(--color-white));
  color: rgb(var(--color-blue-500));

  svg {
    color: hsl(var(--sidebar-accent-foreground));
    color: rgb(var(--color-blue-500));
    //width: 14px;
    //height: 14px;
  }

  &.nav-link--collapsed {
    background-color: hsl(var(--foreground));
    color: hsl(var(--background));

    svg {
      color: hsl(var(--background));
    }
  }
}

.group-label {
  @apply font-medium uppercase tracking-wider px-2 py-1.5;
  color: hsl(var(--sidebar-foreground) / 0.5);
  font-size: 11px;
}

.notif {
  @apply w-5 h-5 flex items-center justify-center rounded-md text-xs;
  background-color: hsl(var(--sidebar-accent));
  color: hsl(var(--sidebar-accent-foreground));
}
</style>
